import { useEffect, useEffectEvent } from 'react';
import { Alert, Platform, ToastAndroid } from 'react-native';
import { recordError } from 'app/lib/monitoring';
import { useTranslation } from 'react-i18next';

interface ShowErrorsProps {
  error: Error | null;
  skipTitle?: boolean;
}

export function ShowErrors({ error, skipTitle }: ShowErrorsProps) {
  const { t } = useTranslation('api-errors');

  const showError = useEffectEvent((nextError: Error) => {
    recordError(nextError);
    const title = skipTitle ? '' : t('generic-title');
    const message = t(nextError.message);
    const toast = Platform.select({
      android: () => ToastAndroid.show(`${skipTitle ? '' : `${title} : `}${message}`, 7000),
      web: () => globalThis.alert([title, message].filter(Boolean).join('\n\n')),
      default: () => Alert.alert(title, message),
    });
    toast();
  });

  useEffect(() => {
    if (error) showError(error);
  }, [error]);

  return null;
}
